import { MDCSnackbar } from "../../../../vendor/mdc.snackbar";
import TooltippsBadges from "../../99-libs/tooltipps-badges";

let snackbar = null;
checkTooltipps();
if (document.querySelector(".mdc-snackbar")) {
  snackbar = new MDCSnackbar(document.querySelector(".mdc-snackbar"));
  $(document).ready(function () {
    $(".cart__left .cart__quantity").on("change", function () {
      /*         this.setAttribute('disabled', true);
                this.parentNode.querySelector("button").setAttribute('disabled', true); */
      $.ajax({
        type: "POST",
        cache: false,
        url: $(this).parents(".cart.container-fluid").data("url"),
        // The key needs to match your method's input parameter (case-sensitive).
        data: JSON.stringify({
          id: $(this).data("uid"),
          isProduct: $(this).data("product"),
          quantity: parseInt(this.value),
          modification: 1,
        }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      })
        .done((data) => {
          if (data.status == 200) {
            $(".header-vts__cart-dot").text(data.count);
            if (data.count == 0) {
              $(".header-vts__cart-dot").addClass("hidden");
            } else {
              $(".header-vts__cart-dot").removeClass("hidden");
            }

            document.querySelector(
              ".mdc-snackbar .mdc-snackbar__label"
            ).textContent = "Cart has been updated";
            snackbar.open();
          } else {
            console.log("A problem occurred when sending your request.");
          }
        })
        .fail(function () {
          alert(
            "An error occurred while processing your request. Please try again."
          );
        });
    });

    $(".cart__remove-item").on("click", function () {
      const removeButton = this;
      $.ajax({
        type: "POST",
        url: $(this).parents(".cart.container-fluid").data("url"),
        cache: false,
        // The key needs to match your method's input parameter (case-sensitive).
        data: JSON.stringify({
          id: $(this).data("uid"),
          isProduct: $(this).data("product"),
          quantity: 0,
          modification: 1,
        }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      })
        .done((data) => {
          if (data.status == 200) {
            $(".header-vts__cart-dot").text(data.count);
            snackbar.labelText = "The article has been removed from your cart";
            snackbar.open();
            removeButton.closest("tr").remove();
            if (data.count == 0) {
              $(".header-vts__cart-dot").addClass("hidden");
              $(".cart__title").text($(".cart__title").data("empty"));
              $(".cart__submit-btn").addClass("disabled");
            } else {
              $(".header-vts__cart-dot").removeClass("hidden");
            }

          } else {
            console.log("A problem occurred when sending your request.");
          }
        })
        .fail(function () {
          alert(
            "An error occurred while processing your request. Please try again."
          );
        });
    });
  });
}

if (document.querySelector(".mdc-snackbar.form-submit-message")) {
  $(document).ready(function () {
    const snackbar = new MDCSnackbar(
      document.querySelector(".mdc-snackbar.form-submit-message")
    );
    snackbar.open();
  });
}

function checkTooltipps() {
  if (!document.querySelector(".cart__table")) return;
  const tooltipps = new TooltippsBadges();
  tooltipps.init();
}

export default snackbar;
